import socket, {IResponse} from '@sockets';
import {useState, useEffect} from 'react';
import {appConfig} from '@config';
import {
	DialogTitle,
	Dialog,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	DialogContent,
	Typography, DialogActions, Button, Divider, ListItemAvatar, Avatar, DialogContentText, IconButton, useTheme
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ParkingServiceIcon from '@icons/ParkingServiceIcon';
import Service from '@components/services/Service';
import ServicesColoredList, {servicesList} from '@components/services/ServiceList';
import {Link} from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import CloseIcon from '@icons/CloseIcon';
import {compare} from 'compare-versions';

type IVersionsHistory = {
	id: number,
	versionNumber: string,
	description: string
}
export default function VersionsHistory() {
	const theme = useTheme();
	const lastAppVersion = localStorage.getItem('app_version') ?? null;
	const [appVersion, setAppVersion] = useState<string>(appConfig.base.version);
	const [open, setOpen] = useState(false);
	const [versionsHistory, setVersionsHistory] = useState<any>([]);
	const [lastVersionsHistory, setLastVersionsHistory] = useState<any>([]);
	const {t} = useTranslation();
	const handleClose = () => {
		localStorage.setItem('app_version', appConfig.base.version);
		setOpen(false);
	};

	const handleListItemClick = (value: string) => {
	};
	useEffect(() => {
		socket.emit('home:get_versions_history', null, (data: IResponse<IVersionsHistory[]>) => {
			if (data.success) {
				// localStorage.setItem('top_services', JSON.stringify(data.result));
				// setAppVersion(services);
				setLastVersionsHistory(data.result.shift());
				setVersionsHistory(data.result);

				if (typeof lastAppVersion === undefined || lastAppVersion == null) {
					setOpen(true);
				} else if (lastAppVersion && compare(appVersion, lastAppVersion, '>')) {
					setOpen(true);
				} else {
					setOpen(false);
				}
			}
		});
	}, []);

	// useEffect(() => {
	// 	if (typeof lastAppVersion === undefined || lastAppVersion == null) {
	// 		setOpen(true);
	// 	} else if (lastAppVersion && semver.gtr(appVersion, lastAppVersion)) {
	// 		setOpen(true);
	// 	} else {
	// 		setOpen(false);
	// 	}
	// 	// localStorage.setItem('app_version', appConfig.base.version);
	// }, []);

	return (
		<Dialog
			onClose={handleClose}
			open={open}
			fullWidth={true}
			maxWidth="sm"
			aria-labelledby="scroll-dialog-title"
			aria-describedby="scroll-dialog-description"
			sx={{
				color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300'
			}}
			PaperProps={{
				style: {
					backgroundColor: theme.palette.mode === 'light' ? 'grey.300' : 'black',
					boxShadow: 'none'
				}
			}}
		>
			<DialogTitle id="scroll-dialog-title">
				<Typography
					sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
						fontSize: (theme) => theme.typography.fontSize + 2
					}}
					className="grow font-medium">
					{t('notifications.title')}
				</Typography>
			</DialogTitle>
			<IconButton
				aria-label="close"
				onClick={handleClose}
				sx={{
					position: 'absolute',
					right: 8,
					top: 8,
					color: (theme) => theme.palette.grey[500]
				}}
			>
				<CloseIcon/>
			</IconButton>
			<DialogContent dividers>
				<DialogContentText id="scroll-dialog-description">
					<Typography
						sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
							fontSize: (theme) => theme.typography.fontSize + 2
						}}
						className="grow font-medium">
						{t('notifications.recent_changes')}
					</Typography>
					<List sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
						width: '100%',
						maxWidth: 360
					}}>
						{
							Object.keys(lastVersionsHistory).length > 0 ? (
								<>
									<ListItem alignItems="flex-start" className="flex flex-col mb-1 mt-1">
										<Typography
											sx={{
												color: (theme) => theme.palette.mode === 'light' ? 'primary.600' : 'secondary50',
												fontSize: (theme) => theme.typography.fontSize
											}}
											className="grow font-medium">
											{t('notifications.version_changes')}: {lastVersionsHistory.versionNumber}
										</Typography>
										<ListItem className="flex flex-row">
											<List sx={{
												color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
												width: '100%',
												maxWidth: 360
												// bgcolor: 'background.paper'
											}}>
												{
													JSON.parse(lastVersionsHistory.description).length > 0 ? (
														JSON.parse(lastVersionsHistory.description).map((desc: any) => (
															<ListItem key={`last_${desc.group}`} alignItems="flex-start"
															          className="items-center mb-2">
																<ListItemAvatar
																	className="flex flex-col justify-center items-center border-l ml-2 pl-1">
																	{
																		servicesList.filter((service) => {
																			return service.name === desc.group;
																		}).map((service) => (
																				<Service key={`last_icon_${service.name}`} service={service} patternIcon={false}/>
																			)
																		)
																	}
																</ListItemAvatar>
																<ListItemText className="flex-start flex-col items-center">
																	{
																		desc.content.map((item: string, index: number) => (
																			<Typography
																				key={`last_content_${index}`}
																				sx={{
																					color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
																					fontSize: (theme) => theme.typography.fontSize
																				}}
																				className="grow font-medium">
																				{/*{t(`services_list.${item}`)}*/}
																				{item}
																			</Typography>
																		))
																	}
																</ListItemText>
															</ListItem>
														))
													) : null
												}
											</List>
										</ListItem>
									</ListItem>
									<Divider variant="inset" component="div" className="mb-3"/>
								</>
							) : null
						}
					</List>
					<Typography
						sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
							fontSize: (theme) => theme.typography.fontSize + 2
						}}
						className="grow font-medium">
						{t('notifications.past_changes')}
					</Typography>
					<SimpleBar
						forceVisible="y"
						autoHide={true}
						className="h-[calc(100vh-550px)] px-3"
					>
						<List sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
							width: '100%',
							maxWidth: 360
							// bgcolor: 'background.paper'
						}} className="h-4/5">
							{
								versionsHistory.length > 0 ? (
									versionsHistory.map((version: any) => (
										<div key={`history_${version.versionNumber}`}>
											<ListItem alignItems="flex-start" className="flex flex-col mb-1 mt-1">
												<Typography
													sx={{
														color: (theme) => theme.palette.mode === 'light' ? version.versionNumber == lastAppVersion ? 'primary.700' : 'primary.800' : version.versionNumber == lastAppVersion ? 'grey.900' : 'secondary50',
														fontSize: (theme) => theme.typography.fontSize,
														bgcolor: (theme) => theme.palette.mode === 'light' ? version.versionNumber == lastAppVersion ? 'grey.100' : '' : version.versionNumber == lastAppVersion ? 'grey.400' : '',
														padding: version.versionNumber == lastAppVersion ? 0.5 : 0
													}}
													className="grow font-medium">
													{t('notifications.version_changes')}: {version.versionNumber}
												</Typography>
												<ListItem>
													<List sx={{
														color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
														width: '100%',
														maxWidth: 360
														// bgcolor: 'background.paper'
													}}>
														{
															JSON.parse(version.description).length > 0 ? (
																JSON.parse(version.description).map((desc: any) => (
																	<ListItem alignItems="flex-start" className="items-center"
																	          key={`history_${desc.group}`}>
																		<ListItemAvatar
																			className="flex flex-col justify-center items-center border-l ml-2 pl-1">
																			{
																				servicesList.filter((service) => {
																					return service.name === desc.group;
																				}).map((service) => (
																						<ServicesColoredList color={'gray'} service={service} patternIcon={false}
																						                     key={`icon_${service.name}`}/>
																						// <Service service={service} patternIcon={false} color={'gray'}/>
																					)
																				)
																			}
																		</ListItemAvatar>
																		<ListItemText className="flex-start flex-col items-center">
																			{
																				desc.content.map((item: string) => (
																					<Typography
																						key={`history_${desc.group}_${item}`}
																						sx={{
																							color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
																							fontSize: (theme) => theme.typography.fontSize
																						}}
																						className="grow font-medium">
																						{/*{t(`services_list.${item}`)}*/}
																						{item}
																					</Typography>
																				))
																			}
																		</ListItemText>
																	</ListItem>
																))
															) : null
														}
													</List>
												</ListItem>
											</ListItem>
											<Divider variant="inset" component="div" className="mb-3"/>
										</div>
									))
								) : null
							}
						</List>
					</SimpleBar>
				</DialogContentText>
			</DialogContent>
			<DialogActions className="justify-center">
				<Button variant={'outlined'} onClick={handleClose}>
					{t('notifications.understood')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
